import { Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import {
  INDICATOR,
  INDICATOR_PRODUCT_SUBSCRIPTION_CONFIGURATION_TYPE,
} from '@/api/rest/resources/types/IndicatorProduct';
import { OrganizationUIStyle } from '@/api/rest/resources/types/organization';
import { useGetIndicatorProductSubscriptionConfigurations } from '@/hooks/useDashboardIndicatorProductSubscriptionConfiguration';
import { useIsStaffUser } from '@/hooks/useIsStaffUser';
import { usePathSet } from '@/hooks/usePathSet';
import { useUIStyle } from '@/hooks/useUIStyle';
import { SignedInPageLayout } from '@/layout/signed-in-page';
import { useMenuItems } from '@/pages/shared/hooks/useMenuItems';
import { useSelectedIndicatorProducts } from '@/pages/shared/indicators/hooks/useIndicatorProducts';

import { LinkCard } from './components/LinkCard';

export const UploadsPage = () => {
  const { t } = useTranslation();
  const menuItems = useMenuItems();
  const pathSet = usePathSet();
  const isStaffUser = useIsStaffUser();

  const hasConservationUIStyle = useUIStyle(OrganizationUIStyle.CONSERVATION);
  const orgIndicatorProducts = useSelectedIndicatorProducts();
  const hasInsituDataIp = orgIndicatorProducts.some((ip) => ip.name === INDICATOR.IN_SITU_PACK);
  const ipConfigurations = useGetIndicatorProductSubscriptionConfigurations()?.data?.results ?? [];

  const hasDefaultConfiguration = ipConfigurations.some(
    (config) => config.type === INDICATOR_PRODUCT_SUBSCRIPTION_CONFIGURATION_TYPE.DEFAULT,
  );
  const hasMapConfiguration = ipConfigurations.some(
    (config) => config.type === INDICATOR_PRODUCT_SUBSCRIPTION_CONFIGURATION_TYPE.MEDIA_MAP,
  );

  return (
    <SignedInPageLayout
      items={menuItems}
      navBarProps={{
        title: t('navbar.uploads'),
      }}
    >
      <Stack spacing={8} direction='row' className='flex-wrap w-full'>
        {hasInsituDataIp && (hasDefaultConfiguration || isStaffUser) && (
          <LinkCard to={pathSet.insituDataUpload} icon='ri-upload-cloud-line' title={t('navbar.insituData')} />
        )}
        {hasInsituDataIp && (hasMapConfiguration || isStaffUser) && (
          <LinkCard to={pathSet.mediaMaps} icon='ri-road-map-line' title={t('navbar.mediaMaps')} />
        )}
        {hasConservationUIStyle && (
          <LinkCard to={pathSet.uploadsPlotOverview} icon='ri-image-add-line' title={t('navbar.uploadsPlotOverview')} />
        )}
      </Stack>
    </SignedInPageLayout>
  );
};
